import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicUndeterminedCoefficients = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="METHOD OF UNDETERMINED COEFFICIENTS"
      videos={[
        "https://www.youtube.com/embed/qWxq1m1TJM0",
        "https://www.youtube.com/embed/044h0H_sjAE",
        "https://www.youtube.com/embed/BvZndZzwrsc",
      ]}
      takeaways={[
        { text: "Remember the following for the yp" ,
         image: "/undetermined.jpg"},

       
        { text: "Practice as many problems as you can" },
        { text: "Taking the yp part is crucial in this type of problems" },
      ]}
      questions={[
        "You may get a problem with part in solution set",
      ]}
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicUndeterminedCoefficients;